import React, { useState, useEffect } from "react";
import { PermList, PermSet } from "../../utils/api";
import Select from "../../ui/Select/Select";
import useGlobals from "../../hooks/useGlobals";

const Perm = () => {
  const [user, setUser] = useState(null);
  const [perms, setPerms] = useState({
    user_perms: [],
    perms_dict: {},
    users: []
  });
  const [loading, setLoading] = useState(false);
  const globals = useGlobals();

  useEffect(() => {
    if (user) {
      setLoading(true);
      PermList({ user_id: user }).then(resp => {
        setPerms(resp);
        setLoading(false);
      });
    }
  }, [user]);

  const onChange = (perm_id, checked) => {
    console.log(perm_id, checked);

    if (checked) {
      setPerms(prev => {
        return {
          ...prev,
          user_perms: [...prev.user_perms, perm_id]
        };
      });
    } else {
      setPerms(prev => {
        return {
          ...prev,
          user_perms: prev.user_perms.filter(id => {
            return id != perm_id;
          })
        };
      });
    }

    PermSet({ perm_id, user_id: user, checked }).then(() => {
      console.log("ok");
    });
  };

  const renderPermList = (title, permList) => {
    return (
      <div>
        <h1 style={{ padding: 10 }}>{title}</h1>
        <table className="table">
          <thead>
            <tr>
              <th style={{ width: 250 }}>Codename</th>
              <th style={{ textAlign: "left" }}>Описание</th>
            </tr>
          </thead>
          <tbody>
            {permList.map(perm => {
              return (
                <tr key={perm.codename}>
                  <td>
                    <input
                      id={perm.id}
                      type="checkbox"
                      checked={perms.user_perms.includes(perm.id)}
                      onChange={e => {
                        onChange(perm.id, e.target.checked);
                      }}
                    />
                    <label htmlFor={perm.id}>{perm.codename}</label>
                  </td>
                  <td style={{ textAlign: "left" }}>{perm.name}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <div className="content-body content-body__with-fixed">
      <Select
        options={globals.content_users}
        searchable
        onSelect={option => {
          setUser(option.value);
        }}
        placeholder="User"
      />

      {user && !loading && (
        <div>
          {renderPermList("Карточки", perms.perms_dict["cards"] || [])}
          {renderPermList("Кампании", perms.perms_dict["campaigns"] || [])}
          {renderPermList("Категории", perms.perms_dict["cats"] || [])}
          {renderPermList("Фильтры", perms.perms_dict["filters"] || [])}
          {renderPermList("Действия", perms.perms_dict["actions"] || [])}
          {renderPermList("Сортировка", perms.perms_dict["sort"] || [])}
          {renderPermList("Отображение", perms.perms_dict["view"] || [])}
        </div>
      )}
    </div>
  );
};

export default Perm;
